import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskChecklistCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-checklist-check" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.252,9V5.249a1.5,1.5,0,0,0-1.5-1.5h-4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.252,3.749h-4a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5H10.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.423,4.736a.751.751,0,0,1-.711.513H7.293a.751.751,0,0,1-.712-.513l-1-3A.749.749,0,0,1,6.293.749h8.419a.749.749,0,0,1,.711.987Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.252,20.249H4.5a.75.75,0,0,1-.75-.75V6.749"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.252,
			y1: 6.749,
			x2: 17.252,
			y2: 8.249
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 17.25,
			cy: 17.249,
			r: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.924,15.5l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.752,
			y1: 9.749,
			x2: 11.252,
			y2: 9.749
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.752,
			y1: 14.249,
			x2: 8.252,
			y2: 14.249
		})
	]
});
export default SvgTaskChecklistCheck;
